import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

export class UpdateApplicationUseCase implements UseCase<SmallBusinessApplication, SfApiResponse<string>> {

  private repository: SmallBusinessRepository;

  public constructor (repository: SmallBusinessRepository) {
    this.repository = repository;
  }

  public async run (application: SmallBusinessApplication): Promise<SfApiResponse<string>> {
    return await this.repository.updateSmallBusinessApplication(application);
  }

}
